import { render } from "./AnnouncementCard.vue?vue&type=template&id=2594ea04"
import script from "./AnnouncementCard.vue?vue&type=script&lang=js"
export * from "./AnnouncementCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__